import { Component, OnInit } from '@angular/core';
import { CorporateService } from '../corporate-service/corporate-service';
import { takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';

@Component({
  selector: 'app-configurations-list',
  templateUrl: './configurations-list.component.html',
  styleUrls: ['./configurations-list.component.css']
})
export class ConfigurationsListComponent implements OnInit {
mappers: any = [];
finalMapper = [];
fundingSources :any= [];
fundingSourceName= []
search;
  constructor(private corporateService: CorporateService) { }

  ngOnInit() {
    this.getFundingSource();

  }




  getFundingSource() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSources = data;
          this.fundingSourceName = data.reduce((obj, item) => (obj[item._id] = item, obj), {})

        }
        this.getConfigurations();

      });

  }

  getConfigurations(){
    this.corporateService
    .getConfigurations()
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.mappers = data;
      }
    });
  }

  ngOnDestroy(): void {
  }
}
